module.exports = __webpack_public_path__ + "img/Water_Land_m.9650d098.svg";